module.exports = "/_next/static/images/BadgeMidMarket@2x-a622b7bc535965cf0c29e057609c5c38.webp";